import claudiaAPI from 'dashboard/api/claudiaAPI';

const state = {
  records: {},
  uiFlags: {},
};

const getters = {
  getConversationEvents: _state => conversationUuid => {
    const events = _state.records[conversationUuid] || [];
    return events.filter(e => !e.messageId);
  },
  getMessageEvents: _state => conversationUuid => {
    const events = _state.records[conversationUuid] || [];
    return events.filter(e => !!e.messageId);
  },
  getUIFlags: _state => conversationUuid => {
    return _state.uiFlags[conversationUuid] || { isFetching: false };
  },
};

const mutations = {
  SET_CLAUDIA_EVENTS(currentState, { conversationUuid, events }) {
    currentState.records = {
      ...currentState.records,
      [conversationUuid]: events,
    };
  },
  SET_UI_FLAG(currentState, { conversationUuid, uiFlags }) {
    currentState.uiFlags = {
      ...currentState.uiFlags,
      [conversationUuid]: {
        ...(currentState.uiFlags[conversationUuid] || {}),
        ...uiFlags,
      },
    };
  },
};

const actions = {
  async fetch({ commit, rootGetters }, { conversationUuid }) {
    commit('SET_UI_FLAG', {
      conversationUuid,
      uiFlags: { isFetching: true },
    });
    try {
      const store = { getters: rootGetters };
      const events = await claudiaAPI.getConversationEvents(
        conversationUuid,
        store
      );
      commit('SET_CLAUDIA_EVENTS', { conversationUuid, events });
    } catch (error) {
      // silently fail — events are supplementary
    } finally {
      commit('SET_UI_FLAG', {
        conversationUuid,
        uiFlags: { isFetching: false },
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
